import { createQueryKeys } from '@lukemorales/query-key-factory';

export const agentActivity = createQueryKeys('agentActivity', {
  list: (params: { days: number; market: string; search: string }) => [params],
  detail: (userId: string, days: number) => [userId, days],
});
